import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { UtilsService } from "../../../../auth/service/utils.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { CustomerService } from "../../../../modules/customer/customer.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DealsService } from "../../../../auth/service/deals.service";
import { CommissionService } from "../../../../auth/service/commission.service";
import { OrdersService } from "../../../../auth/service/orders.service";
import { locale as italian } from "../../../../i18n/it";
import moment from "moment";
import { IDetailTimeMaterial, IRound } from "../../../../auth/models/round-interface";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { IdealBE } from "../../../../auth/models/deal-inferface";
import { ListService } from "../../../../auth/service/list.service";
import { animate, style, transition, trigger } from "@angular/animations";
import { ProductsCommissionsService } from "../../../../modules/products/products-commissions.service";
import { ICustomer } from "../../../../modules/customer/customer.interface";

@Component({
  selector: "app-commission-edit",
  templateUrl: "./commission-edit.component.html",
  styleUrls: ["./commission-edit.component.scss"],
  animations: [
    trigger("inOutAnimation", [
      transition(":enter", [style({ opacity: 0 }), animate("0.3s ease-out", style({ opacity: 1 }))]),
      transition(":leave", [style({ opacity: 1 }), animate("0.2s ease-in", style({ opacity: 0 }))]),
    ]),
  ],
})
export class CommissionEditComponent implements OnInit {
  @ViewChild("detailOrder") detailOrder: ElementRef;
  @ViewChild("roundConflictDecision") roundConflictDecision: ElementRef;
  @ViewChild("addNewOrder") addNewOrder: ElementRef;
  public contentHeader: IContentHeader;
  public formGroupDetail: FormGroup;
  public formGroupOrder: FormGroup;
  public formNewOrder: FormGroup;
  public currentCommission: any = {};
  public customersList: Array<ICustomer> = [];
  public employeesList: any = [];
  public employeesListWithExEmployee: any = [];
  public paymentsTermsList: Array<any> = [];
  public billingFrequencyList: Array<any> = [];
  public dealsList: Array<IdealBE> = [];
  public dealsFilteredList: Array<IdealBE> = [];
  public timeMaterialEffort: number = 0;
  public activeTab: string = "economic-graph";
  public orderList: Array<any> = [];
  public economicList: Array<any> = [];
  public selectedDeal: any = null;
  public typeDeal: string = null;
  public showErrors: boolean = false;
  public commissionID: number = null;
  public timeMaterialEmployee: Array<IDetailTimeMaterial> = [];
  public taskEmployee: Array<any> = [];
  public files_list: Array<any> = [];
  public files_list_obj: Array<any> = [];
  public attachments_list: Array<any> = [];
  public attachments_list_obj: Array<any> = [];
  public order_document: any = null;
  public order_document_name: string = null;
  public dealId: any = null;
  public closeMotivation: string = null;
  public editModeOrder: boolean = false;
  public todayDate: moment.Moment = moment();
  public selectedOrder: any = null;
  public selectedOrderChild: any = null;
  public editModeOrderChild: boolean = false;
  public actionAddRound: boolean = false;
  public actionAddRoundDealId: number = null;
  public actionEditOrderId: number = null;
  public total_estimated_cost: number = 0;
  public total_estimated_revenue: number = 0;
  public total_real_cost: number = 0;
  public total_real_profit: number = 0;
  public total_margin_euro: number = 0;
  public total_provider_cost: number = 0;
  public total_margin_percentage: number = 0;
  public detachmentTypes: string[] = ["distacco", "delta"];
  public invoiceTypeList: any[] = [];
  public paymentMeasureUnitList: any[] = [];
  public conflictRoundDetail: any = null;
  public openDetailEmployee: boolean = false;
  public closeDate: any = moment().format("YYYY-MM-DD");
  public filterAnalyticsYear: number = moment().year();
  public analyticsYears: number[] = [];
  private lastModalOpened: any = null;
  public openSecondaryOrders: boolean = false;
  private firstProposal: boolean = false; //Usiamo per capire se la prima volta che gli si presenta l'offerta dopo viene settata a false
  public productsCommissions: any = [];
  public isCopingPrevDocument: boolean = false;
  public isCopingPrevOrderDetail: boolean = false;
  public closeRoundDate: any = null;
  public childOrderFile: any = null;

  regenerateYear = moment().year();
  regenerateMonth = moment().month() + 1;
  monthsList = moment.months();

  constructor(
    public _utilService: UtilsService,
    public router: Router,
    public _authService: AuthenticationService,
    public _customerService: CustomerService,
    public _formBuilder: FormBuilder,
    public _modalService: NgbModal,
    public _changeDetectorRef: ChangeDetectorRef,
    public _dealService: DealsService,
    public _userService: UserService,
    private _listService: ListService,
    private activatedRoute: ActivatedRoute,
    private _commissionService: CommissionService,
    private _orderService: OrdersService,
    private _productsCommissionsService: ProductsCommissionsService,
  ) {
    this._utilService.disableAutoHideLoading();
    this.activatedRoute.params.subscribe((params) => {
      this.commissionID = Number(params.id);
    });
    this.activatedRoute.queryParams.subscribe((params) => {
      this.actionEditOrderId = Number(params.order_id);
      this.actionAddRound = params.add_order || params.add_deal_order;
      this.actionAddRoundDealId = Number(params.add_deal_order);

      if (params.tab_name) {
        this.activeTab = params.tab_name;
      } else {
        setTimeout(() => {
          //Carichiamo prima il grafico se no si bagga
          this.activeTab = "orders";
        }, 305);
      }
    });

    this.contentHeader = {
      headerTitle: "MENU.EDIT_COMMISSION",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.COMMISSION",
            isLink: true,
            link: "/dashboard/commission/list",
          },
          {
            name: "MENU.EDIT_COMMISSION",
            isLink: false,
          },
        ],
      },
    };
    this.formGroupDetail = this._formBuilder.group({
      customer: new FormControl(null, [Validators.required]),
      name: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
      detachment: new FormControl(false),
    });
    this.formGroupOrder = this._formBuilder.group({
      deal_id: new FormControl(null, [Validators.required]),
      order_number: new FormControl(null),
      order_date: new FormControl(null),
      employees_hash: new FormControl(null, [Validators.required]),
      from: new FormControl(null, [Validators.required]),
      to: new FormControl(null, [Validators.required]),
      capacity: new FormControl(null, [Validators.required]),
      invoice_type: new FormControl(null, [Validators.required]),
      payment_measure_unit: new FormControl(null, [Validators.required]),
      residue: new FormControl(null, [Validators.required]),
      description: new FormControl(null, [Validators.maxLength(1000)]),
      order_description: new FormControl(null, [Validators.maxLength(1000)]),
      payment_terms: new FormControl(null, [Validators.required]),
      billing_frequency: new FormControl(null, [Validators.required]),
      tranche_import: new FormControl(null),
      tranche_number: new FormControl(null),
      client_approval: new FormControl(false),
      detailTimeMaterial: new FormControl(null),
      detachment_type: new FormControl(null),
      product_commission_id: new FormControl(null),
      order_cig: new FormControl(null, [Validators.maxLength(10)]),
      order_cup: new FormControl(null, [Validators.maxLength(15)]),
    });
    this.formNewOrder = this._formBuilder.group({
      order_number: new FormControl(null, [Validators.required]),
      order_date: new FormControl(null, [Validators.required]),
      order_capacity: new FormControl(null, [Validators.required]),
      invoice_type: new FormControl(null, [Validators.required]),
      payment_measure_unit: new FormControl(null, [Validators.required]),
      order_residue: new FormControl(null, [Validators.required]),
      order_description: new FormControl(null, [Validators.required, Validators.maxLength(1000)]),
      payment_terms: new FormControl(null, [Validators.required]),
      billing_frequency: new FormControl(null, [Validators.required]),
      order_type: new FormControl(null, [Validators.required]),
      order_cig: new FormControl(null, [Validators.maxLength(10)]),
      order_cup: new FormControl(null, [Validators.maxLength(15)]),
    });
  }

  async ngOnInit() {
    this._utilService.showLoading();
    if (!this._authService.hasCapability("edit_commission")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    //La lista viene caricata nell app component metto timeout per essere sicuro che venga chiamato prima l'app component

    if (this._userService.allUserList.length < 1) {
      await this._userService.getAllUsers();
    }
    setTimeout(() => {
      this.employeesListWithExEmployee = this._userService.allUserList.filter((u) => u);
      this.employeesList = this._userService.allUserList.filter((user) => user.type_code !== "ex-employee");
      this.employeesList = this.employeesList.sort((a: any, b: any) => (a.lastname > b.lastname ? 1 : -1));
    }, 500);

    this.productsCommissions = await this._productsCommissionsService.getCommissions().catch(() => []);
    //List form back-end
    this.customersList = await this._customerService.getCustomers();
    this.customersList = this.customersList.sort((a, b) => (a.name > b.name ? 1 : -1));

    this.paymentsTermsList = await this._listService.getList("payment_terms");
    this.billingFrequencyList = await this._listService.getList("billing_frequency");
    this.paymentMeasureUnitList = await this._listService.getList("payment_measure_unit");
    this.invoiceTypeList = await this._listService.getList("invoice_document_type").then((invoiceType) => invoiceType.filter((item: any) => !item.other.credit_note));
    await this.loadCommission();

    //If true it's mean the user arrived in this page from order list and want to add a new order
    if (this.actionAddRound) {
      if (!this._authService.hasCapability("create_order")) {
        this._utilService.hideLoading();
        await this.router.navigateByUrl("/dashboard/main");
        return false;
      }
      this.firstProposal = true;
      await this.modalOpen(this.detailOrder, null);
    }
    //If it has an id it's mean the user arrived in this page from order list and want to edit an order
    if (this.actionEditOrderId) {
      if (!this._authService.hasCapability("edit_order")) {
        this._utilService.hideLoading();
        await this.router.navigateByUrl("/dashboard/main");
        return false;
      }
      const order = this.orderList.find((orderItem: any) => orderItem.order_id == this.actionEditOrderId);
      if (!order) {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "NOT_FOUND_ROUND" });
        return false;
      }
      await this.modalOpen(this.detailOrder, order);
    }
    this._utilService.hideLoading();
  }

  async loadCommission() {
    //Reset array (Useful when load Commission is called not for the first time)
    this.orderList = [];
    this.economicList = [];
    this.total_estimated_cost = 0;
    this.total_estimated_revenue = 0;
    this.dealsList = await this._dealService.getDeals();
    this.dealsList = this.dealsList.reverse();

    //If a deal has a commission is not available, so we take only deals without a commission ID and deals with the current commission ID
    this.dealsList = this.dealsList.filter((deal) => !deal.commission.id || deal.commission.id === this.commissionID);
    await this._commissionService
      .getCommission(this.commissionID)
      .then(async (response: any) => {
        this.currentCommission = response;
        if (!!this.currentCommission) {
          try {
            this.formGroupDetail.patchValue({
              customer: this.currentCommission.client?.id || null,
              name: this.currentCommission.name,
              detachment: this.currentCommission.detachment,
            });

            // ordinamento dei round nel dettaglio amministrativo
            if (this.currentCommission.orders && this.currentCommission.orders.length > 0) {
              const hasDetachment: boolean = !!this.currentCommission.orders[0].detachment_type;
              const ordersForLoop: any = !hasDetachment ? this.currentCommission.orders : this.currentCommission.orders.filter((order: any) => order.detachment_type === "delta");

              //Sort for have order descending
              ordersForLoop.map((order: any) => {
                this.addOrderToArray(order);
                if (hasDetachment) {
                  const findDetachment: any = this.currentCommission.orders.find((o: any) => o.detachment_type === "distacco" && o.deal_id === order.deal_id);
                  this.addOrderToArray(findDetachment);
                }
              });
            }
            // ordinamento dei mesi nel dettaglio economico
            if (this.currentCommission.commission_analytics && this.currentCommission.commission_analytics.length > 0) {
              this.currentCommission.commission_analytics.map((analytics: any) => {
                if (!!analytics.year && !this.analyticsYears.includes(analytics.year)) {
                  this.analyticsYears.push(analytics.year);
                }
              });
              //Rimuovo le analytics che non hanno order_id e filtro per l'anno selezionato
              this.currentCommission.commission_analytics = this.currentCommission.commission_analytics.filter((item: any) => !!item.order_id);

              // filtro per anno
              const countWithFilterYear: number = this.currentCommission.commission_analytics.filter((item: any) => item.year === Number(this.filterAnalyticsYear)).length;
              if (countWithFilterYear < 1) {
                this.filterAnalyticsYear = this.filterAnalyticsYear - 1;
              }

              // vedo se è un distacco
              const hasDetachment: boolean =
                this.currentCommission && this.currentCommission.commission_analytics && this.currentCommission.commission_analytics[0] && this.currentCommission.commission_analytics[0].detachment_type;
              this.currentCommission.commission_analytics = this.currentCommission.commission_analytics.filter((item: any) => item.year === Number(this.filterAnalyticsYear));

              if (hasDetachment) {
                const elements: any = this.currentCommission.commission_analytics
                  .filter((item: any) => item.detachment_type === "delta")
                  .sort((a: any, b: any) => {
                    a = Number(a.month);
                    b = Number(b.month);
                    return a > b ? -1 : a < b ? 1 : 0;
                  });

                for (let i = 0; i < elements.length; i++) {
                  const analytic = elements[i];
                  this.addAnalyticToArray(analytic);
                  const findDetachment: any = this.currentCommission.commission_analytics.find((item: any) => {
                    return item.detachment_type === "distacco" && item.order_id === analytic.order_id && item.month === analytic.month && item.year === analytic.year;
                  });
                  if (findDetachment) {
                    this.addAnalyticToArray(findDetachment);
                  }
                }
              } else {
                this.currentCommission.commission_analytics
                  .sort((a: any, b: any) => {
                    a = Number(a.month);
                    b = Number(b.month);
                    return a > b ? -1 : a < b ? 1 : 0;
                  })
                  .map((analytic: any) => this.addAnalyticToArray(analytic));
              }

              this.total_estimated_cost = 0;
              this.total_real_cost = 0;
              this.total_provider_cost = 0;
              this.total_estimated_revenue = 0;
              this.total_real_profit = 0;
              this.total_margin_euro = 0;
              this.total_margin_percentage = 0;

              this.economicList = this.economicList.map((economic: any) => {
                economic.effective_cost = 0;
                economic.provider_cost = economic.provider_cost ? this._utilService.removeDotsFromNumber(economic.provider_cost) : 0;
                economic.effective_revenue = 0;
                economic.estimated_cost = 0;
                economic.estimated_revenue = 0;
                economic.percentage_margin = 0;
                economic.euro_margin = 0;
                economic.effective_cost_color = null;
                economic.effective_revenue_color = null;
                economic.margin_color = null;
                economic.order_type = this.currentCommission.orders.find((order: any) => order.id === economic.order_number).detail_task?.length ? "task" : "time_material";

                for (const details of economic.employee_details) {
                  details.real_profit = this._utilService.removeDotsFromNumber(details.real_profit.toString());
                  details.real_cost = this._utilService.removeDotsFromNumber(details.real_cost.toString());

                  if (details.type_code === "product") {
                    details.euro_margin = details.real_profit - details.real_cost;
                    if (details.real_cost === 0) {
                      details.percentage_margin = 100;
                    } else {
                      details.percentage_margin = this._utilService.calculatePercentageBetweenTwoNumbers(details.real_profit, details.real_cost);
                    }
                  } else {
                    details.real_profit = details.real_profit || 0;
                    details.real_cost = details.real_cost || 0;

                    details.euro_margin = details.real_cost > 0 ? details.real_profit - details.real_cost : 0;

                    economic.effective_cost += details.real_cost === 0 ? 0 : details.real_cost;
                    economic.effective_revenue += details.real_profit === 0 ? 0 : details.real_profit;
                    economic.estimated_cost += details.estimated_cost === 0 ? 0 : this._utilService.removeDotsFromNumber(details.estimated_cost || "0");
                    economic.estimated_revenue += this._utilService.removeDotsFromNumber(details.estimated_revenue || "0");
                    details.percentage_margin = 0;

                    if (details.real_cost > 0) {
                      if (details.real_cost > details.real_profit) {
                        details.percentage_margin = details.real_profit - details.real_cost;
                        details.percentage_margin = details.percentage_margin < 1 ? 0 : Number(((details.percentage_margin / details.real_profit) * 100).toFixed(2));
                      } else {
                        details.percentage_margin = this._utilService.calculatePercentageBetweenTwoNumbers(details.real_profit, details.real_cost);
                      }
                    }
                  }
                }

                // Colorazione per costo, fatturato e margine se positivi o negativi per alcune percentuali
                if (!!economic.effective_revenue && !!economic.estimated_revenue) {
                  const percentageEffectiveRevenue = this._utilService.calculatePercentageBetweenTwoNumbers(economic.effective_revenue, economic.estimated_revenue);
                  economic.effective_revenue_color = percentageEffectiveRevenue >= this._utilService.themeConfiguration.commission_percentage_profit ? "success" : "danger";
                }

                // Colorazione per costo, fatturato e margine se positivi o negativi per alcune percentuali
                if (!!economic.effective_cost && !!economic.estimated_cost) {
                  const percentageEffectiveCost = this._utilService.calculatePercentageBetweenTwoNumbers(economic.effective_cost, economic.estimated_cost);
                  economic.effective_cost_color = percentageEffectiveCost <= this._utilService.themeConfiguration.commission_percentage_cost ? "success" : "danger";
                }

                if (!!economic.effective_cost || !!economic.provider_cost) {
                  const costs = economic.effective_cost + economic.provider_cost;
                  if (economic.effective_revenue > 0) {
                    economic.percentage_margin = this._utilService.calculatePercentageBetweenTwoNumbers(economic.effective_revenue, costs);
                  }
                }

                if (!!economic.percentage_margin && economic.percentage_margin < this._utilService.themeConfiguration.request_margin) {
                  economic.margin_color = "danger";
                }

                if (!!economic.effective_cost || !!economic.provider_cost) {
                  economic.euro_margin = economic.effective_revenue - (economic.effective_cost + economic.provider_cost);
                }

                this.total_estimated_cost += economic.estimated_cost;
                this.total_real_cost += economic.effective_cost;
                this.total_provider_cost += economic.provider_cost;
                this.total_estimated_revenue += economic.estimated_revenue;
                this.total_real_profit += economic.effective_revenue;
                this.total_margin_euro += economic.euro_margin;

                economic.effective_cost = this._utilService.addDotsToNumber(economic.effective_cost);
                economic.provider_cost = this._utilService.addDotsToNumber(economic.provider_cost);
                economic.effective_revenue = this._utilService.addDotsToNumber(economic.effective_revenue);
                economic.estimated_cost = this._utilService.addDotsToNumber(economic.estimated_cost);
                economic.estimated_revenue = this._utilService.addDotsToNumber(economic.estimated_revenue);
                economic.euro_margin = !!economic.euro_margin ? this._utilService.addDotsToNumber(economic.euro_margin) : 0;

                return economic;
              });

              this.total_margin_percentage = this.total_real_profit < 1 ? 0 : this._utilService.calculatePercentageBetweenTwoNumbers(this.total_real_profit, this.total_real_cost);
              this.total_estimated_revenue = this._utilService.addDotsToNumber(this.total_estimated_revenue);
              this.total_estimated_cost = this._utilService.addDotsToNumber(this.total_estimated_cost);
              this.total_real_cost = this._utilService.addDotsToNumber(this.total_real_cost);
              this.total_real_profit = this._utilService.addDotsToNumber(this.total_real_profit);
              this.total_margin_euro = this._utilService.addDotsToNumber(this.total_margin_euro);
              this.total_provider_cost = this._utilService.addDotsToNumber(this.total_provider_cost);

              //Color copule row for detachment
              if (this.orderList && this.orderList.length > 0 && this.formGroupDetail.value.detachment) {
                let makeCouple: number = 0;
                let progressiveIdDetachment: number = 1;
                this.orderList.map((order: any) => {
                  makeCouple += 1;
                  order.progressive_id = `#${String(progressiveIdDetachment).padStart(2, "0")}`;
                  order.classStyle = makeCouple === 1 || makeCouple === 2 ? "grey" : "white";
                  if (this.economicList && this.economicList.length > 0) {
                    this.economicList.map((eco: any) => {
                      if (eco.order_number === order.order_id) {
                        eco.progressive_id = order.progressive_id;
                        eco.classStyle = makeCouple === 1 || makeCouple === 2 ? "grey" : "white";
                      }
                    });
                  }
                  if (makeCouple === 2 || makeCouple === 4) {
                    progressiveIdDetachment += 1;
                  }
                  if (makeCouple === 4) {
                    makeCouple = 0;
                  }
                });
              }
              if (this.orderList && this.orderList.length > 0) {
                if (!this.formGroupDetail.value.detachment) {
                  this.orderList.map((order: any, index: number) => {
                    order.progressive_id = `#${String(index + 1).padStart(2, "0")}`;
                    order.classStyle = "white";
                    if (this.economicList && this.economicList.length > 0) {
                      this.economicList.map((eco: any) => {
                        if (eco.order_number === order.order_id) {
                          eco.progressive_id = order.progressive_id;
                          eco.classStyle = "white";
                        }
                      });
                    }
                  });
                } else {
                  this.styleAnalyticsDetachment();
                }
              }
              this._commissionService.onDetailEconomicChange.next(this.economicList);
            }
          } catch (error) {
            console.error(error);
          }
        } else {
          //Show Error if we don't have found a commission
          await this._utilService.showSWALError({ text: "ERROR_NOT_FOUND_COMMISSION" });
          await this.router.navigateByUrl("/dashboard/commission/list");
          return false;
        }
      })
      .catch((err) => {
        if (err === "Unauthorized") {
          this.router.navigateByUrl("/dashboard/commission/list");
          this._utilService.showToastrError("NOT_AUTHORIZED");
          return false;
        }
      });
  }

  private addAnalyticToArray(analytic: any) {
    analytic.employees_analytics = analytic.employees_analytics || [];
    analytic.products_analytics = analytic.products_analytics || [];

    const employeeDetails: any = analytic.employees_analytics.map((employee: any) => {
      return {
        type_code: employee.type_code,
        employee_hash: employee.hash,
        employee_name: employee.complete_name,
        commissions_number: employee.commissions_number,
        estimated_cost: !!employee.estimate_cost ? this._utilService.addDotsToNumber(employee.estimate_cost) : 0,
        estimated_revenue: !!employee.estimate_profit ? this._utilService.addDotsToNumber(employee.estimate_profit) : 0,
        real_cost: !!employee.real_cost ? this._utilService.addDotsToNumber(employee.real_cost) : 0,
        real_profit: !!employee.real_profit ? this._utilService.addDotsToNumber(employee.real_profit) : 0,
        daily_cost: !!employee.cost_total_daily ? this._utilService.addDotsToNumber(employee.cost_total_daily) : 0,
        daily_rate: !!employee.daily_rate ? this._utilService.addDotsToNumber(employee.daily_rate) : 0,
        working_days: analytic.working_days ? analytic.working_days : 0,
        invoiced_days: employee.invoiced_days ? employee.invoiced_days : 0,
      };
    });

    analytic.products_analytics.map((product: any) => {
      employeeDetails.push({
        type_code: "product",
        id: product.id,
        name: product.name,
        commissions_number: product.commissions_number,
        estimated_cost: !!product.estimate_cost ? this._utilService.addDotsToNumber(product.estimate_cost) : 0,
        estimated_revenue: !!product.estimate_profit ? this._utilService.addDotsToNumber(product.estimate_profit) : 0,
        real_cost: !!product.real_cost ? this._utilService.addDotsToNumber(product.real_cost) : 0,
        real_profit: !!product.real_profit ? this._utilService.addDotsToNumber(product.real_profit) : 0,
      });
    });

    this.economicList.push({
      order_number: analytic.order_id,
      month: !!analytic.month && !!analytic.year ? `${String(analytic.month).padStart(2, "0")} ${analytic?.year}` : null,
      year: !!analytic.year ? Number(analytic.year) : null,
      estimated_cost: 0,
      effective_cost: null,
      commissions_number: 0,
      estimated_revenue: 0,
      effective_revenue: 0,
      percentage_margin: null,
      euro_margin: null,
      month_value: analytic.month,
      year_value: analytic.year,
      provider_cost: !!analytic.provider_cost ? this._utilService.addDotsToNumber(analytic.provider_cost) : 0,
      employee_details: employeeDetails,
      open_modal: false,
      progressive_id: !!analytic?.progressive_id ? analytic.progressive_id : null,
      detachment_type: analytic?.detachment_type ? analytic?.detachment_type : null,
    });

    //Calcolo margine totale
    this.total_margin_euro = this.total_real_profit - (this.total_real_cost + this.total_provider_cost);
    const multiplicationTotalMargin: number = this.total_margin_euro * 100;
    //Controllo che siano maggiori di zero. Se entrambi fossero di valore zero il risultato sarebbe NaN
    if (!!multiplicationTotalMargin && this.total_real_profit) {
      this.total_margin_percentage = Number((multiplicationTotalMargin / this.total_real_profit).toFixed(2));
    }
  }

  styleAnalyticsDetachment() {
    if (this.economicList && this.economicList.length > 0) {
      let makeCouple: number = 0;
      this.economicList.map((order: any) => {
        makeCouple += 1;
        order.classStyle = makeCouple === 1 || makeCouple === 2 ? "grey" : "white";
        if (this.economicList && this.economicList.length > 0) {
          this.economicList.map((eco: any) => {
            if (eco.order_number === order.order_id) {
              eco.progressive_id = order.progressive_id;
              eco.classStyle = makeCouple === 1 || makeCouple === 2 ? "grey" : "white";
            }
          });
        }
        if (makeCouple === 4) {
          makeCouple = 0;
        }
      });
    }
  }

  private addOrderToArray(order: any) {
    /*legend status order
     * NOT_STARTED 0 It will be possible to change everything
     * STARTED && ACTIVATED 1 It will be possible to change only end_date and name
     * EXPIRED 2 There is no edit if the order/order is expired*/
    let statusOrder: { status: number; color: string; label: string; closed_date: string } = {
      status: 0,
      color: "warning",
      label: "NOT_STARTED",
      closed_date: null,
    };

    if (moment(order?.from) <= this.todayDate && moment(order?.to) > this.todayDate && !order.closed) {
      statusOrder = {
        status: 1,
        color: "success",
        label: "ACTIVATED_MASCULIN",
        closed_date: null,
      }; //STARTED && ACTIVATED
    }

    if (moment(order?.to) < this.todayDate && !order.closed) {
      statusOrder = {
        status: 2,
        color: "danger",
        label: italian.data.EXPIRED,
        closed_date: null,
      }; //EXPIRED
    }

    if (order.closed) {
      statusOrder = {
        status: 3,
        color: "danger",
        label: "CLOSE_MASCULIN",
        closed_date: order.closed_date ? moment(order.closed_date).format("DD/MM/YYYY") : null,
      }; //CLOSED
    }

    this.orderList.push({
      id: order?.id,
      deal_id: order?.deal_id ? order.deal_id : null,
      deal_name: order?.deal_name ? order.deal_name : null,
      employees_hash: order?.employees_hash ? order.employees_hash : null,
      employees_names: (order.employees || []).map((employee: any) => employee.complete_name),
      from: order?.from ? this._utilService.formatDate(order.from, "YYYY-MM-DD") : null,
      to: order?.to ? this._utilService.formatDate(order.to, "YYYY-MM-DD") : null,
      capacity: order?.capacity ? this._utilService.addDotsToNumber(order.capacity) : null,
      residue: order?.residue ? this._utilService.addDotsToNumber(order.residue) : null,
      order_number: order?.order_number ? order.order_number : null,
      order_date: order?.order_date ? this._utilService.formatDate(order.order_date, "YYYY-MM-DD") : null,
      description: order?.description ? order.description : null,
      order_description: order?.order_description ? order.order_description : null,
      payment_terms: order?.payment_terms_id ? order.payment_terms_id : null,
      tranche_import: order?.tranche_import ? this._utilService.addDotsToNumber(order.tranche_import) : null,
      tranche_number: order?.tranche_number ? order.tranche_number : null,
      billing_frequency: order?.billing_frequency_id ? order.billing_frequency_id : null,
      effort: order?.effort ? order.effort : null,
      invoice_type: order?.invoice_type ? order.invoice_type : null,
      payment_measure_unit: order?.payment_measure_unit ? order.payment_measure_unit : null,
      daily_rate: order?.deal_id ? this._utilService.addDotsToNumber(order.daily_rate) : null,
      file_url: order?.file_url ? order.file_url : null,
      file_name: order?.file_name ? order.file_name : null,
      order_attachments: order?.attachments ? order.attachments : null,
      status_order: statusOrder,
      closed: order.closed,
      status: order.status, //OPEN(0) OR CLOSED(1)
      order_id: order?.id ? order.id : null,
      detail_time_material: order?.detail_time_material ? order?.detail_time_material : [],
      detail_task: order?.detail_task ? order?.detail_task : [],
      client_approval: order.client_approval,
      progressive_id: order?.progressive_id ? order?.progressive_id : null,
      detachment_type: order?.detachment_type ? order?.detachment_type : null,
      order_children: order?.order_children ? order?.order_children : [],
      total_capacity: order.order_children && order.order_children.length > 0 ? (order.capacity += order.order_children.reduce((acc, obj) => acc + obj.order_capacity, 0)) : order.capacity ? order.capacity : null,
      total_residue: order.order_children && order.order_children.length > 0 ? (order.residue += order.order_children.reduce((acc, obj) => acc + obj.order_residue, 0)) : order.residue ? order.residue : null,
      product_commission_id: order?.product_commission_id ? order.product_commission_id : null,
      order_cig: order?.order_cig ? order.order_cig : null,
      order_cup: order?.order_cup ? order.order_cup : null,
    });

    if (order.detachment_type === "distacco" && (!order.order_attachments || order.order_attachments.length < 1)) {
      const delta = this.orderList.find((item: any) => item.detachment_type === "delta");
      if (!!delta) {
        //  this.orderList[index].order_attachments = delta.order_attachments;

        const relativeOrder: any = this.orderList.find((o: any) => o.id === order.id);
        if (relativeOrder) {
          if (delta && delta.complete_name) {
            relativeOrder.order_attachments.push(delta.complete_name);
          }
        }
      }
    }
  }

  ///////////////////////////////////////////////////////////////GENERAL FUNCTIONS////////////////////////////////

  getRowClass(row): string {
    if (row.classStyle === "grey") {
      return "bg-light-secondary text-dark";
    }
  }

  changeTab(tab: string) {
    this.activeTab = this.activeTab === tab ? "" : tab;
  }

  fieldHasErrors(field_name: string): boolean {
    if (this.showErrors) {
      return this.formGroupOrder.controls[field_name].status === "INVALID";
    } else {
      return this.formGroupOrder.controls[field_name].status === "INVALID" && this.formGroupOrder.controls[field_name].touched;
    }
  }

  fieldHasErrorsNewOrder(field_name: string): boolean {
    if (this.showErrors) {
      return this.formNewOrder.controls[field_name].status === "INVALID";
    } else {
      return this.formNewOrder.controls[field_name].status === "INVALID" && this.formNewOrder.controls[field_name].touched;
    }
  }

  isDetachment(row: any) {
    return !row.detachment_type || row.detachment_type !== "delta";
  }

  async modalOpen(modalBasic, currentOrder: any) {
    this._utilService.hideLoading();
    const modalName = modalBasic?._declarationTContainer?.localNames[0];
    if (modalName !== "closeCommissionModal" && modalName !== "roundConflictDecision" && modalName !== "addNewOrder") this.selectedOrder = null;
    this.filterDeals();
    //If is already present an order, we patch the values for let the user edit these values
    if (this.formGroupDetail.value.detachment) {
      this.formGroupOrder.patchValue({
        detachment_type: "distacco",
      });
    }

    if (!!currentOrder) {
      this.editModeOrder = true;

      // se è un round che deve ancora iniziare tolgo gli ex dipendenti
      if (moment(currentOrder.from) > this.todayDate) {
        currentOrder.employees_hash = currentOrder.employees_hash.filter((hash: string) => this.employeesList.find((e: any) => e.hash === hash));
        currentOrder.employees_names = currentOrder.employees_names.filter((complete_name: string) => this.employeesList.find((e: any) => e.complete_name === complete_name));
        if (currentOrder.detail_task && Array.isArray(currentOrder.detail_task)) {
          currentOrder.detail_task = currentOrder.detail_task.filter((task: any) => this.employeesList.find((e: any) => e.hash === task.employee_hash));
        }
        if (currentOrder.detail_time_material && Array.isArray(currentOrder.detail_time_material)) {
          currentOrder.detail_time_material = currentOrder.detail_time_material.filter((task: any) => this.employeesList.find((e: any) => e.hash === task.employee_hash));
        }
      }

      this.selectedOrder = currentOrder;
      this.formGroupOrder.patchValue({
        deal_id: currentOrder.deal_id,
        order_number: currentOrder.order_number,
        order_date: currentOrder.order_date,
        employees_hash: currentOrder.employees_hash,
        from: currentOrder.from,
        to: currentOrder.to,
        capacity: currentOrder.capacity || 0,
        residue: currentOrder.residue || 0,
        order_description: currentOrder.order_description,
        description: currentOrder.description,
        payment_terms: currentOrder.payment_terms,
        invoice_type: currentOrder.invoice_type,
        payment_measure_unit: currentOrder.payment_measure_unit,
        billing_frequency: currentOrder.billing_frequency,
        effort: currentOrder.effort || 0,
        daily_rate: currentOrder.daily_rate || 0,
        tranche_import: currentOrder.tranche_import || 0,
        tranche_number: currentOrder.tranche_number,
        client_approval: currentOrder.client_approval,
        order_id: currentOrder.id,
        detachment_type: this.formGroupDetail.value.detachment ? "distacco" : null,
        product_commission_id: currentOrder.product_commission_id,
        order_cig: currentOrder.order_cig,
        order_cup: currentOrder.order_cup,
      });
      //Here we fill the time material array
      this.timeMaterialEmployee = currentOrder.detail_time_material;
      this.taskEmployee = currentOrder.detail_task;
      if (!!currentOrder.file_url) {
        this.order_document = currentOrder.file_url;
        this.order_document_name = currentOrder.file_name;
      }
      this.typeDeal = !!currentOrder.tranche_number && !!currentOrder.tranche_import ? "Task" : "Time Material";
      await this.selectDeal(true);
    } else {
      this.openDetailEmployee = true;
      if (modalName !== "closeCommissionModal" && modalName !== "roundConflictDecision" && modalName !== "addNewOrder") {
        //check if there is an available deal without commission
        this.dealsFilteredList = this.dealsFilteredList.filter((deal) => !deal.commission.id);
        if (this.dealsFilteredList && this.dealsFilteredList.length < 1) {
          await this._utilService.showSWALError({ text: "NO_DEALS_FOR_SELECTED_CUSTOMER" });
          return false;
        } else {
          //If there is only one deal we push it directly to the selectedDeal
          if (this.dealsFilteredList && this.dealsFilteredList.length === 1) {
            this.dealId = this.dealsFilteredList[0].id;
            this.formGroupOrder.patchValue({
              deal_id: this.dealId,
            });
            await this.selectDeal();
          }
        }
        this.editModeOrder = false;
      }
    }
    if (!!this.actionAddRoundDealId) {
      //It means the user come from deals_list and want to add a new round and have already the deal id
      this.dealId = this.actionAddRoundDealId;
      this.formGroupOrder.patchValue({
        deal_id: this.actionAddRoundDealId,
      });
      await this.selectDeal();
    }
    const modalSizes: { closeCommissionModal: string; roundConflictDecision: string; addNewOrder: string; detailOrder: string } = {
      closeCommissionModal: "sm",
      roundConflictDecision: "sm",
      addNewOrder: "lg",
      detailOrder: "xl",
    };

    this.lastModalOpened = this._modalService.open(modalBasic, {
      size: !!modalName && modalSizes[modalName] ? modalSizes[modalName] : "xl",
      centered: true,
      keyboard: false,
      backdrop: false,
    });
  }

  async openModalCloseRound(modalBasic, currentOrder: any) {
    this.selectedOrder = currentOrder;
    if (this.selectedOrder) {
      if (!this.selectedOrder.closed) {
        this._modalService.open(modalBasic, {
          size: "sm",
          centered: true,
          keyboard: false,
          backdrop: false,
        });
      } else {
        await this.manageStatusOrder();
      }
    }
  }

  async openModalEditChildOrder(modal, currentOrder: any) {
    this._utilService.hideLoading();

    if (!!currentOrder) {
      this.editModeOrderChild = true;
      this.selectedOrderChild = currentOrder;
      this.formNewOrder.patchValue({
        order_number: currentOrder.order_number,
        order_date: this._utilService.formatDate(currentOrder.order_date, "YYYY-MM-DD"),
        order_capacity: this._utilService.addDotsToNumber(currentOrder.order_capacity) || 0,
        order_residue: this._utilService.addDotsToNumber(currentOrder.order_residue) || 0,
        order_description: currentOrder.order_description,
        payment_terms: currentOrder.payment_terms,
        invoice_type: currentOrder.invoice_type,
        payment_measure_unit: currentOrder.payment_measure_unit,
        billing_frequency: currentOrder.billing_frequency,
        order_type: currentOrder.order_type,
        order_cig: currentOrder.order_cig,
        order_cup: currentOrder.order_cup,
      });
      this.childOrderFile = currentOrder.file_url;
    }
    this.lastModalOpened = this._modalService.open(modal, {
      size: "lg",
      centered: true,
      keyboard: false,
      backdrop: false,
    });
  }

  modalClose() {
    this._modalService.dismissAll();
    this.formGroupOrder.reset();
    this.selectedOrder = null;
    this.conflictRoundDetail = null;
    this.typeDeal = null;
    this.selectedDeal = null;
    this.actionAddRoundDealId = null;
    this.actionEditOrderId = null;
    this.actionAddRound = false;
    this.dealId = null;
    this.closeMotivation = null;
    this.timeMaterialEmployee = [];
    this.taskEmployee = [];
    this.files_list = [];
    this.files_list_obj = [];
    this.attachments_list = [];
    this.attachments_list_obj = [];
    this.order_document = null;
    this.order_document_name = null;
    this.openSecondaryOrders = false;
    this.isCopingPrevDocument = false;
    this.isCopingPrevOrderDetail = false;
    this.closeRoundDate = null;
  }

  modalCloseNewOrder() {
    this.formNewOrder.reset();
    this.lastModalOpened.close();
    this.lastModalOpened = null;
    this.selectedOrderChild = null;
    this.childOrderFile = null;
  }

  //Funzione per gestire le date
  takeDate(event: any, field: string) {
    if (field === "from") {
      this.formGroupOrder.patchValue({
        from: event,
      });
      if (!!event) {
        this.calculateEffortTimeMaterial();
        this.calculateTrancheNumberAndFrequency();
      }
    }
    if (field === "to") {
      this.formGroupOrder.patchValue({
        to: event,
      });
      if (!!event) {
        this.calculateEffortTimeMaterial();
        this.calculateTrancheNumberAndFrequency();
      }
    }
    if (field === "order_date") {
      this.formGroupOrder.patchValue({
        order_date: event,
      });
    }
    if (field === "close_date") {
      this.closeDate = event;
    }
    if (field === "new_order_date") {
      this.formNewOrder.patchValue({
        order_date: event,
      });
    }
    if (field === "closeRoundDate") {
      this.closeRoundDate = event;
    }
  }

  resetCapacityAndResidue() {
    this.formGroupOrder.patchValue({
      capacity: null,
      residue: null,
    });
  }

  ///////////////////////////////////////////////////////////////TASK FUNCTIONS////////////////////////////////

  calculateSingleTrancheTaskOnInit(discount: string, line_amount: string): string {
    if (this.formGroupOrder.value.tranche_number) {
      if (!discount) {
        if (!!line_amount) {
          return this._utilService.addDotsToNumber(this._utilService.removeDotsFromNumber(line_amount) / this.formGroupOrder.value.tranche_number);
        } else {
          return "0,00";
        }
      } else {
        if (!!discount) {
          return this._utilService.addDotsToNumber(this._utilService.removeDotsFromNumber(discount) / this.formGroupOrder.value.tranche_number);
        } else {
          return "0,00";
        }
      }
    } else {
      return "0,00";
    }
  }

  calculateCapacityTaskOnInit() {
    this.showErrors = false;
    if (!this.formGroupOrder.value.from || !this.formGroupOrder.value.to) {
      this.showErrors = true;
      return false;
    }
    this.resetCapacityAndResidue();
    //If is present tranche_import and tranche_number we're going to calculate capacity and residue
    if (this.taskEmployee && this.taskEmployee.length > 0) {
      this.taskEmployee.forEach((row) => {
        row.tranche_single_import = this.calculateSingleTrancheTaskOnInit(row.discount, row.line_amount);
        if (!!this.formGroupOrder.value.tranche_number && this.formGroupOrder.value.tranche_number > 0 && !!row.tranche_single_import) {
          let capacity: number = this.formGroupOrder.value.tranche_number * this._utilService.removeDotsFromNumber(row.tranche_single_import);
          const discount: number = row.discount ? this._utilService.removeDotsFromNumber(row.discount) : 0;
          if (discount && discount !== 0) {
            //If there is a discount we're going to calculate discount divide by effort
            //Check if we have to round the value, if is it zero we don't need to round it
            let toDoMathRound: number = discount % (discount / this.formGroupOrder.value.tranche_number);
            row.tranche_single_import = this._utilService.addDotsToNumber(toDoMathRound !== 0 ? Math.round(discount / this.formGroupOrder.value.tranche_number) : discount / this.formGroupOrder.value.tranche_number);
            capacity = this.formGroupOrder.value.tranche_number * this._utilService.removeDotsFromNumber(row.tranche_single_import);
            this.formGroupOrder.patchValue({
              capacity: !!this.formGroupOrder.value.capacity ? (this.formGroupOrder.value.capacity += capacity) : capacity,
              residue: !!this.formGroupOrder.value.residue ? (this.formGroupOrder.value.residue += capacity) : capacity,
            });
          } else {
            this.formGroupOrder.patchValue({
              capacity: !!this.formGroupOrder.value.capacity ? (this.formGroupOrder.value.capacity += capacity) : capacity,
              residue: !!this.formGroupOrder.value.residue ? (this.formGroupOrder.value.residue += capacity) : capacity,
            });
          }
        }
      });
    }
    //Adding dots to capacity and residue
    if (!!this.formGroupOrder.value.capacity && !!this.formGroupOrder.value.residue) {
      this.formGroupOrder.patchValue({
        capacity: this._utilService.addDotsToNumber(this.formGroupOrder.value.capacity),
        residue: this._utilService.addDotsToNumber(this.formGroupOrder.value.residue),
      });
    }
  }

  calculateCapacityAndTrancheImportSingleAndGeneral(): void {
    if (this.taskEmployee && this.taskEmployee.length > 0) {
      let sumAllTrancheImport: number = 0;
      this.taskEmployee.map((emp: any) => {
        if (!!emp.monthly_import && this.formGroupOrder.value.tranche_number && emp.months) {
          emp.tranche_single_import = this._utilService.addDotsToNumber((emp.months * this._utilService.removeDotsFromNumber(emp.monthly_import)) / this.formGroupOrder.value.tranche_number);
        }
        if (!!emp.tranche_single_import) {
          sumAllTrancheImport += this._utilService.removeDotsFromNumber(emp.tranche_single_import);
        }
      });
      this.formGroupOrder.patchValue({
        tranche_import: this._utilService.addDotsToNumber(sumAllTrancheImport),
        capacity: this._utilService.addDotsToNumber(sumAllTrancheImport * this.formGroupOrder.value.tranche_number),
        residue: this._utilService.addDotsToNumber(sumAllTrancheImport * this.formGroupOrder.value.tranche_number),
      });
    }
  }

  manageTaskRow() {
    //Checking that a user has been deleted
    if (this.taskEmployee && this.taskEmployee.length > 0) {
      this.taskEmployee.map((item: any, index: number) => {
        if (item.employee_hash && !this.formGroupOrder.value.employees_hash.includes(item.employee_hash)) {
          //If a user it's been removed we show an alert
          if (this.taskEmployee.length < 2) {
            this.taskEmployee.pop();
          } else {
            this.taskEmployee.splice(index, 1);
            this.taskEmployee = this.taskEmployee.filter((i) => i);
          }
        }
      });
    }

    //Checking that a user has been added
    if (this.formGroupOrder.value.employees_hash && this.formGroupOrder.value.employees_hash.length > 0) {
      this.formGroupOrder.value.employees_hash.map((employee_hash: string, index: number) => {
        const alreadyInDatatable = this.taskEmployee.find((row) => row.employee_hash === employee_hash);
        if (!alreadyInDatatable) {
          this.taskEmployee.push({
            employee_hash: employee_hash ? employee_hash : null,
            employee_name: this.employeesList.find((emp) => emp.hash === employee_hash)?.complete_name,
            tranche_single_import: null,
            months: this.calculateMonthNumber(),
            monthly_import: null,
          });
          if (this.selectedDeal && this.selectedDeal.deal_document && this.selectedDeal.deal_document.table) {
            const employee = this.selectedDeal.deal_document.table.find((row) => row.employee_hash === employee_hash);
            if (!!employee && !!employee.monthly_canon) {
              this.taskEmployee[index].monthly_import = employee.discount ? this._utilService.addDotsToNumber(this._utilService.removeDotsFromNumber(employee.discount) / employee.months_number) : employee.monthly_canon;
              this.taskEmployee[index].tranche_single_import = null; //Calcolo nella funzione calculate Capacity task
              this.taskEmployee[index].discount = employee.discount;
              this.taskEmployee[index].months = employee.months_number;
              this.taskEmployee[index].line_amount = employee.line_amount;
            }
          }
        }
      });
    }
    this.calculateCapacityTaskOnInit();
  }

  calculateMonthNumber(): number {
    const startDate: moment.Moment = moment(this.formGroupOrder.value.from);
    const endDate: moment.Moment = moment(this.formGroupOrder.value.to);
    const month = Math.round(endDate.diff(startDate, "months", true));
    if (!!this.formGroupOrder.value.from && !!this.formGroupOrder.value.to && month > 1) {
      return month;
    } else {
      return 1;
    }
  }

  assignMonthNumberTask(): void {
    if (this.taskEmployee && this.taskEmployee.length > 0) {
      this.taskEmployee.map((emp: any) => {
        emp.months = this.calculateMonthNumber();
      });
    }
  }

  async calculateTrancheNumberAndFrequency() {
    this.showErrors = false;
    if (this.typeDeal === "Task") {
      const startDate: moment.Moment = moment(this.formGroupOrder.value.from).clone();
      const endDate: moment.Moment = moment(this.formGroupOrder.value.to).clone();
      if (this.formGroupOrder.value.from && this.formGroupOrder.value.to) {
        if (startDate > endDate) {
          this.showErrors = true;
          await this._utilService.showSWALError({ text: "ERROR_DATE" });
          return false;
        }
        this.formGroupOrder.patchValue({
          tranche_number: endDate.diff(startDate, "months") < 1 ? 1 : Math.round(endDate.diff(startDate, "months", true)),
        });
        this.assignMonthNumberTask();
        if (!!this.formGroupOrder.value.billing_frequency) {
          const billing: any = this.billingFrequencyList.find((i: any) => i.id === this.formGroupOrder.value.billing_frequency);
          let tranche: any = this.formGroupOrder.value.tranche_number;
          if (!!tranche) {
            const differenceTranche: number = Math.round(tranche / billing.other.month_value);
            this.formGroupOrder.patchValue({
              tranche_number: differenceTranche < 1 ? 1 : differenceTranche,
            });
            if (this.formGroupOrder.value.tranche_number === 0) {
              this.formGroupOrder.patchValue({
                tranche_number: 1,
              });
            }
          }
        }
      }
      this.calculateCapacityAndTrancheImportSingleAndGeneral();
    }
  }

  ///////////////////////////////////////////////////////////////TIME MATERIAL FUNCTIONS////////////////////////////////
  //Function for calculating the capacity in case is selected Time Material as a deal's type
  calculateCapacityTimeMaterialOnInit() {
    this.resetCapacityAndResidue();
    //If is present effort and daily_rate we're going to calculate capacity and residue
    if (this.timeMaterialEmployee && this.timeMaterialEmployee.length > 0) {
      this.timeMaterialEmployee.forEach((row) => {
        if (!!row.effort && row.effort > 0 && !!row.daily_rate) {
          let capacity: number = row.effort * this._utilService.removeDotsFromNumber(row.daily_rate);
          const discount: number = row.discount ? this._utilService.removeDotsFromNumber(row.discount) : 0;
          const lineAmount: number = row.line_amount ? this._utilService.removeDotsFromNumber(row.line_amount) : 0;
          if (discount < lineAmount && discount !== 0) {
            //If there is a discount we're going to calculate discount divide by effort
            //Check if we have to round the value, if is it zero we don't need to round it
            let toDoMathRound: number = discount % (discount / row.effort);
            row.daily_rate = this._utilService.addDotsToNumber(toDoMathRound !== 0 ? Math.round(discount / row.effort) : discount / row.effort);
            capacity = row.effort * this._utilService.removeDotsFromNumber(row.daily_rate);
            this.formGroupOrder.patchValue({
              capacity: !!this.formGroupOrder.value.capacity ? (this.formGroupOrder.value.capacity += capacity) : capacity,
              residue: !!this.formGroupOrder.value.residue ? (this.formGroupOrder.value.residue += capacity) : capacity,
            });
          } else {
            this.formGroupOrder.patchValue({
              capacity: !!this.formGroupOrder.value.capacity ? (this.formGroupOrder.value.capacity += capacity) : capacity,
              residue: !!this.formGroupOrder.value.residue ? (this.formGroupOrder.value.residue += capacity) : capacity,
            });
          }
        }
      });
    }
    //Adding dots to capacity and residue
    if (!!this.formGroupOrder.value.capacity && !!this.formGroupOrder.value.residue) {
      this.formGroupOrder.patchValue({
        capacity: this._utilService.addDotsToNumber(this.formGroupOrder.value.capacity),
        residue: this._utilService.addDotsToNumber(this.formGroupOrder.value.residue),
      });
    }
  }

  calculateCapacityTimeMaterial() {
    this.resetCapacityAndResidue();
    //If is present effort and daily_rate we're going to calculate capacity and residue
    if (this.timeMaterialEmployee && this.timeMaterialEmployee.length > 0) {
      this.timeMaterialEmployee.forEach((row) => {
        if (!!row.effort && row.effort > 0 && !!row.daily_rate) {
          let capacity: number = row.effort * this._utilService.removeDotsFromNumber(row.daily_rate);
          this.formGroupOrder.patchValue({
            capacity: !!this.formGroupOrder.value.capacity ? (this.formGroupOrder.value.capacity += capacity) : capacity,
            residue: !!this.formGroupOrder.value.residue ? (this.formGroupOrder.value.residue += capacity) : capacity,
          });
        }
      });
    }
    //Adding dots to capacity and residue
    if (!!this.formGroupOrder.value.capacity && !!this.formGroupOrder.value.residue) {
      this.formGroupOrder.patchValue({
        capacity: this._utilService.addDotsToNumber(this.formGroupOrder.value.capacity),
        residue: this._utilService.addDotsToNumber(this.formGroupOrder.value.residue),
      });
    }
  }

  //In case the deal is Time Material we'll have multiple inputs for each employee selected
  manageTimeMaterialRow() {
    //Checking that a user has been deleted
    if (this.timeMaterialEmployee && this.timeMaterialEmployee.length > 0) {
      this.timeMaterialEmployee.map((item: any, index: number) => {
        if (item.employee_hash && !this.formGroupOrder.value.employees_hash.includes(item.employee_hash)) {
          //If a user it's been removed we show an alert
          if (this.timeMaterialEmployee.length < 2) {
            this.timeMaterialEmployee.pop();
          } else {
            this.timeMaterialEmployee.splice(index, 1);
            this.timeMaterialEmployee = this.timeMaterialEmployee.filter((i) => i);
          }
        }
      });
    }
    //Checking that a user has been added
    if (this.formGroupOrder.value.employees_hash && this.formGroupOrder.value.employees_hash.length > 0) {
      this.formGroupOrder.value.employees_hash.map((employee_hash: string, index: number) => {
        const alreadyInDatatable = this.timeMaterialEmployee.find((row) => row.employee_hash === employee_hash);
        if (!alreadyInDatatable) {
          this.timeMaterialEmployee.push({
            effort: this.timeMaterialEffort,
            employee_hash: employee_hash ? employee_hash : null,
            employee_name: this.employeesList.find((emp) => emp.hash === employee_hash).complete_name,
            daily_rate: null,
            discount: null,
            line_amount: null,
          });
          if (this.selectedDeal && this.selectedDeal.deal_document && this.selectedDeal.deal_document.table) {
            const employeeDailyRate = this.selectedDeal.deal_document.table.find((row) => row.employee_hash === employee_hash);
            if (!!employeeDailyRate && !!employeeDailyRate.daily_rate) {
              this.timeMaterialEmployee[index].daily_rate = employeeDailyRate.daily_rate;
              this.timeMaterialEmployee[index].discount = employeeDailyRate.discount;
              this.timeMaterialEmployee[index].line_amount = employeeDailyRate.line_amount;
            }
          }
        }
      });
    }
    this.calculateCapacityTimeMaterialOnInit();
  }

  calculateEffortTimeMaterial() {
    if (this.typeDeal === "Time Material") {
      if (!this.firstProposal) {
        //Qui entra dopo che all'utente è stata già presenta l'offerta di default
        if (this.formGroupOrder.value.from && this.formGroupOrder.value.to && this.typeDeal === "Time Material") {
          let totalEffort: number = 0;
          const availableWorkingDays = this._utilService.themeConfiguration.working_days;
          const startDate: moment.Moment = moment(this.formGroupOrder.value.from);
          const endDate: moment.Moment = moment(this.formGroupOrder.value.to);
          const numberOfDays: number = endDate.diff(startDate, "days");
          if (typeof numberOfDays == "number" && numberOfDays > 0) {
            for (let i: number = 0; i <= numberOfDays; i++) {
              const date: string = startDate.clone().add(i, "days").format("YYYY-MM-DD");
              //If is not saturday or sunday or an italian holiday we add a day
              //availableWorkingDays contains the working days if you change these in the options, maybe the not working days will be different
              if (availableWorkingDays.includes(Number(moment(date).format("d")))) {
                if (!this._utilService.isHoliday(date)) {
                  totalEffort += 1;
                }
              }
            }
            this.timeMaterialEffort = totalEffort;
            //Insert the effort total for each employee
            if (this.timeMaterialEmployee && this.timeMaterialEmployee.length > 0) {
              this.timeMaterialEmployee.map((emp) => (emp.effort = this.timeMaterialEffort));
            }
          }
        }
      } else {
        //Qui entra la prima volta che vengono presentati i dati dall'offerta infatti poi firstProposal sarà sempre false
        if (this.timeMaterialEmployee && this.timeMaterialEmployee.length > 0 && this.selectedDeal.deal_document.table && this.selectedDeal.deal_document.table.length > 0) {
          this.timeMaterialEmployee.map((emp) => {
            const findUser = this.selectedDeal.deal_document.table.find((user) => user.employee_hash === emp.employee_hash);
            emp.effort = findUser && findUser.total_effort ? Number(findUser.total_effort) : 0;
          });
        }
      }

      //Here we're going to recalculate the capacity because the effort is changed
      this.calculateCapacityTimeMaterial();
    }
    this.firstProposal = false;
  }

  ///////////////////////////////////////////////////////////////FORMAT MONEY FUNCTIONS////////////////////////////////

  formatMoneyValue(field: any) {
    this.formGroupOrder.patchValue({ [field]: this._utilService.addDotsToNumber(this.formGroupOrder.value[field]) });
    if (field === "capacity") {
      this.formGroupOrder.patchValue({
        //Residue it will always be filled as a capacity value
        residue: this.formGroupOrder.value.capacity,
      });
    }
    if (field === "new_capacity") {
      this.formNewOrder.patchValue({
        //Residue it will always be filled as a capacity value
        order_capacity: this._utilService.addDotsToNumber(this.formNewOrder.value.order_capacity),
        order_residue: this._utilService.addDotsToNumber(this.formNewOrder.value.order_capacity),
      });
    }
  }

  formatDailyRate(index: number) {
    this.timeMaterialEmployee[index].daily_rate = this._utilService.addDotsToNumber(this.timeMaterialEmployee[index].daily_rate);
  }

  formatMonthlyImport(index: number) {
    this.taskEmployee[index].monthly_import = this._utilService.addDotsToNumber(this.taskEmployee[index].monthly_import);
    this.calculateCapacityAndTrancheImportSingleAndGeneral();
  }

  //Function for filtering deals of the customer selected in detail commission
  async selectDeal(edit: boolean = false) {
    if (!edit) {
      //Reset employee time material array
      this.timeMaterialEmployee = [];
      this.taskEmployee = [];
      //Save the selected deal in a variable
      this._utilService.showLoading();
      await this._dealService
        .getDeal(this.formGroupOrder.value.deal_id)
        .then((response: any) => {
          this.selectedDeal = response;
          //Also the type we're going to save
          this.typeDeal = this.selectedDeal.deal_type;
          //Here if we have soma values from the deal we're going to put in our formOrder
          this.formGroupOrder.patchValue({
            billing_frequency: this.selectedDeal?.billing_frequency ? this.selectedDeal.billing_frequency : null,
            from: this.selectedDeal?.start_date ? this._utilService.formatDate(this.selectedDeal.start_date, "YYYY-MM-DD") : null,
            to: this.selectedDeal?.end_date ? this._utilService.formatDate(this.selectedDeal.end_date, "YYYY-MM-DD") : null,
          });
          //Here the same for the employees
          if (this.selectedDeal.employees && this.selectedDeal.employees.length > 0) {
            let employeesHashes: any = [];
            this.selectedDeal.employees.map((emp: any) => {
              if (!!emp.hash && this.employeesList.find((e) => e.hash === emp.hash)) {
                employeesHashes.push(emp.hash);
              }
            });
            this.formGroupOrder.patchValue({
              employees_hash: employeesHashes,
            });
          }
          this._utilService.hideLoading();
          //We call changTypeDeal for resetting some values and calculate effort and add users if they are present in the selected deal
          this.changeTypeDeal();
        })
        .catch(() => {
          this._utilService.hideLoading();
          this._utilService.showSWALError({ text: "ERROR_GET_DEAL" });
        });
    } else {
      this.selectedDeal = this.dealsList.find((d) => d.id === this.formGroupOrder.value.deal_id);
    }
  }

  //Function for filtering deals of the customer selected in detail commission
  filterDeals() {
    if (!!this.formGroupDetail.value.customer) {
      this.dealsFilteredList = this.dealsList.filter((d: any) => d.client.id === this.formGroupDetail.value.customer);
      this.productsCommissions = this.productsCommissions.filter((p) => p.client_id === this.formGroupDetail.value.customer);
    }
  }

  changeTypeDeal() {
    //Reset values before calculating
    this.timeMaterialEmployee = [];
    this.taskEmployee = [];
    this.formGroupOrder.patchValue({
      tranche_number: null,
      tranche_import: null,
      payment_measure_unit: null,
    });
    //If is time material we're going to calculateTheEffort and we call manageTimeMaterial
    if (this.typeDeal === "Time Material") {
      this.manageTimeMaterialRow();
      this.calculateEffortTimeMaterial();
    } else {
      this.manageTaskRow();
      //Here we suggest capacity only for the first time or when deal_type change
      const defaultPaymentForTask = this.paymentMeasureUnitList.find((el) => el.name.toLowerCase().includes("numero"));
      if (!!defaultPaymentForTask) {
        this.formGroupOrder.patchValue({
          payment_measure_unit: defaultPaymentForTask.id,
        });
      }
      if (!!this.selectedDeal.tranche_number) {
        const discountDeal: number = this._utilService.removeDotsFromNumber(this.selectedDeal?.deal_document?.table[0]?.total_discounted_deal);
        const totalDeal: number = this._utilService.removeDotsFromNumber(this.selectedDeal?.deal_document?.table[0]?.total_deal);
        let importTranche: any = 0;
        if (discountDeal < totalDeal && discountDeal !== 0) {
          //If there is a discount we're going to calculate discount divide by tranche_number
          //Check if we have to round the value, if is it zero we don't need to round it
          let toDoMathRound: number = discountDeal % (discountDeal / this.selectedDeal.tranche_number);
          importTranche = this._utilService.addDotsToNumber(toDoMathRound !== 0 ? Math.round(discountDeal / this.selectedDeal.tranche_number) : discountDeal / this.selectedDeal.tranche_number);
        } else {
          importTranche = this._utilService.addDotsToNumber(totalDeal / this.selectedDeal.tranche_number);
        }
        this.formGroupOrder.patchValue({
          tranche_number: this.selectedDeal.tranche_number,
          tranche_import: importTranche,
        });
        this.calculateCapacityTaskOnInit();
      }
    }
  }

  openEconomicDetail(index: number) {
    this.economicList[index].open_modal = !this.economicList[index].open_modal;
  }

  //////////////////////////////////////////////////////////////// FILES FUNCTIONS////////////////////////////////
  async addFileToList(files: any) {
    //Reset variable, it will contain just one file, so if addFileToList is called we're gonna to overwrite the file list
    let updatedList: any[] = [];
    //For all files charged
    for (let file of files) {
      // controllo le dimensioni
      if (file.size > 10000000) {
        await this._utilService.showSWALError({ text: "ERROR_MAX_FILE_SIZE" });
        continue;
      }
      //I add the file to the list that will be uploaded later
      this.files_list.push(file);
      //I add the file to the update list
      updatedList.push({
        name: file.name,
        size: this._utilService.formatBytes(file.size),
        status: 0,
      });
    }
    // I updated the variable for the page
    this.files_list_obj = updatedList;
  }

  resetFilesList() {
    this.files_list_obj = [];
    this.files_list = [];
  }

  removeFileFromList(index: any) {
    this.files_list_obj = this.files_list_obj.filter((item: any, i: number) => i !== index);
    this.files_list = this.files_list.filter((item: any, i: number) => i !== index);
  }

  //Attachments functions
  async addAttachmentToChildOrder(file: any) {
    this.childOrderFile = file ? file : null;
  }

  //Attachments functions
  async addAttachmentToList(files: any) {
    // I create a variable from the actual list
    let updatedList: any[] = this.attachments_list_obj.filter((item: any) => item.name !== "");
    //For all files charged in the queue
    for (let file of files) {
      //check dimensions
      if (file.size > 10000000) {
        await this._utilService.showSWALError({ text: "ERROR_MAX_FILE_SIZE" });
        continue;
      }
      //If exits in the list I'll remove it
      const exists: any = updatedList.find((item: any) => item.name === file.name);
      // If exists remove it
      if (exists) {
        updatedList = updatedList.find((item: any) => item.name === file.name);
      }
      //If it does not exist I'll add it
      else {
        this.attachments_list.push(file);
      }
      //Add to updated list
      updatedList.push({
        name: file.name,
        size: this._utilService.formatBytes(file.size),
        status: 0,
      });
    }
    //I update the variable for the page
    this.attachments_list_obj = updatedList;
  }

  resetAttachmentsList() {
    this.attachments_list_obj = [];
    this.attachments_list = [];
  }

  removeAttachmentFromList(index: any) {
    this.attachments_list_obj = this.attachments_list_obj.filter((item: any, i: number) => i !== index);
    this.attachments_list = this.attachments_list.filter((item: any, i: number) => i !== index);
  }

  async uploadFiles(order_id: number) {
    // I'll wait for all files to be uploaded
    await Promise.all(this.files_list.map((file: File) => this._orderService.uploadDocument(file, order_id))).catch(async () => {
      await this._utilService.showSWALError({ text: "ERROR_UPLOAD_FILE" });
    });
  }

  async uploadAttachments(order_id: number) {
    this._utilService.showLoading();
    // I'll wait for all attachments to be uploaded
    await Promise.all(this.attachments_list.map((file: File) => this._orderService.uploadAttachment(file, order_id))).catch(() => this._utilService.showSWALError({ text: "ERROR_UPLOAD_FILE" }));
  }

  async deleteAttachment(id: number) {
    await this._utilService
      .showSWAL({
        title: "CONFIRM_DELETE_FILE",
        icon: "error",
        confirmButtonText: "CONFIRM_DELETE_BTN",
        customClass: {
          confirmButton: "btn btn-danger",
        },
      })
      .then(async (result) => {
        if (result.value) {
          await this._orderService
            .deleteAttachment(id)
            .then(async () => {
              this.selectedOrder.order_attachments = this.selectedOrder.order_attachments.filter((item) => item.id !== id);
              await this._utilService.showSWALSuccess({ text: "SUCCESS_DELETE_FILE" });
            })
            .catch(() => this._utilService.showSWALError({ text: "ERROR_DELETE_FILE" }));
        } else if (result.isDismissed) {
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      });
  }

  async deleteChildAttachment(id: number) {
    try {
      const modal = await this._utilService.showSWAL({
        title: "CONFIRM_DELETE_FILE",
        icon: "error",
        confirmButtonText: "CONFIRM_DELETE_BTN",
        customClass: {
          confirmButton: "btn btn-danger",
        },
      });

      if (modal.value) {
        try {
          const deleteAttachment: any = await this._orderService.deleteChildAttachment(id);
          if (deleteAttachment?.message && deleteAttachment?.message === "File deleted successfully") {
            this.selectedOrder.order_children.find((child: any) => (child.id = id)).file_url = null;
            return await this._utilService.showSWALSuccess({ text: "SUCCESS_DELETE_FILE" });
          }
        } catch (e) {
          console.error(e);
          return this._utilService.showSWALError({ text: "ERROR_DELETE_FILE" });
        }
      } else if (modal.isDismissed) {
        return await this._utilService.showSWALError({
          title: "ABORTED_TITLE",
          text: "ABORTED_TEXT",
        });
      }
    } catch (e) {
      console.error(e);
      return this._utilService.showSWALError({ text: "ERROR_DELETE_FILE" });
    }
  }

  async deleteDocument() {
    await this._utilService
      .showSWAL({
        title: "CONFIRM_DELETE_FILE",
        icon: "error",
        confirmButtonText: "CONFIRM_DELETE_BTN",
        customClass: {
          confirmButton: "btn btn-danger",
        },
      })
      .then(async (result) => {
        if (result.value) {
          await this._orderService
            .deleteDocument(this.selectedOrder.id)
            .then(async () => {
              this.order_document = null;
              this.selectedOrder.file_url = null;
              await this._utilService.showSWALSuccess({ text: "SUCCESS_DELETE_FILE" });
            })
            .catch(() => this._utilService.showSWALError({ text: "ERROR_DELETE_FILE" }));
        } else if (result.isDismissed) {
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      });
  }

  async manageStatusOrder() {
    let data: { closed_date: string } = {
      closed_date: null,
    };
    if (this.selectedOrder && !this.selectedOrder.closed) {
      if (!this.closeRoundDate) {
        this.showErrors = true;
        return false;
      }
      data.closed_date = moment(this.closeRoundDate).format("YYYY-MM-DD");
    }
    this._utilService.showLoading();
    this._orderService
      .manageStatusOrder(this.selectedOrder.id, data)
      .then(async () => {
        await this.loadCommission();
        this._modalService.dismissAll();
        this._utilService.hideLoading();
        if (this.selectedOrder && !this.selectedOrder.closed) {
          await this._utilService.showSWALSuccess({ text: "SUCCESS_CLOSE_ROUND" });
        } else {
          await this._utilService.showSWALSuccess({ text: "SUCCESS_REOPEN_ROUND" });
        }
        this.modalClose();
      })
      .catch(async () => {
        this._utilService.hideLoading();
        if (this.selectedOrder && !this.selectedOrder.closed) {
          await this._utilService.showSWALError({ text: "ERROR_CLOSE_ROUND" });
        } else {
          await this._utilService.showSWALError({ text: "ERROR_REOPEN_ROUND" });
        }
      });
  }

  isClosingCommission(closedDate: any): boolean {
    return moment(closedDate) > this.todayDate;
  }

  //Funzione che viene invocata quando si sta creando un nuovo round ed uno già presente va in conflitto con il round che si sta creando, si chiede all'utente se ha intenzione di chiudere il round precedente il giorno prima dell'inizio del nuovo round
  async changeEndDateRoundBefore() {
    let data: any = {
      deal_id: this.conflictRoundDetail.conflictRound.deal_id,
      employees_hash: this.conflictRoundDetail.conflictRound.employees_hash,
      detachment_type: null,
      from: this.conflictRoundDetail.conflictRound.from,
      to: moment(this.conflictRoundDetail.newEndDate).add(23, "hours").add(59, "minutes").add(59, "seconds").format("YYYY-MM-DD HH:mm:ss"),
      capacity: this.conflictRoundDetail.conflictRound.capacity,
      invoice_type: this.conflictRoundDetail.conflictRound.invoice_type,
      payment_measure_unit: this.conflictRoundDetail.conflictRound.payment_measure_unit,
      residue: this.conflictRoundDetail.conflictRound.residue,
      order_number: this.conflictRoundDetail.conflictRound.order_number,
      order_date: !!this.conflictRoundDetail.conflictRound.order_date ? this.conflictRoundDetail.conflictRound.order_date : null,
      description: this.conflictRoundDetail.conflictRound.description,
      order_description: this.conflictRoundDetail.conflictRound.order_description,
      payment_terms: this.conflictRoundDetail.conflictRound.payment_terms,
      billing_frequency: this.conflictRoundDetail.conflictRound.billing_frequency,
      detail_time_material: this.timeMaterialEmployee,
      detail_task: this.taskEmployee,
      tranche_import: this.conflictRoundDetail.conflictRound.tranche_import,
      tranche_number: this.conflictRoundDetail.conflictRound.tranche_number,
      client_approval: this.conflictRoundDetail.conflictRound.client_approval,
      commission_id: this.currentCommission.id,
      order_cig: this.conflictRoundDetail.conflictRound.order_cig,
      order_cup: this.conflictRoundDetail.conflictRound.order_cup,
    };
    this._utilService.showLoading();
    await this._orderService
      .editOrder(this.conflictRoundDetail.roundBeforeId, data)
      .then(async () => {
        await this.loadCommission();
        if (this.editModeOrder) {
          await this.editOrder();
        } else {
          await this.createOrder();
        }
        this._utilService.hideLoading();
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_EDIT_ROUND_DATE" });
      });
  }

  async createOrder() {
    if (!this._authService.hasCapability("create_order")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.showErrors = false;
    let timeMaterialUsersError: boolean = false;
    let taskUsersError: boolean = false;
    if (this.formGroupOrder.invalid) {
      await this._utilService.showSWALError({ text: "ERROR_EMPTY_FIELDS" });
      this.showErrors = true;
      return false;
    }

    //Check date
    if (moment(this.formGroupOrder.value.from) > moment(this.formGroupOrder.value.to)) {
      await this._utilService.showSWALError({ text: "ERROR_DATE" });
      return false;
    }

    //Check Candidate Start Contract
    if (this.formGroupOrder.value.employees_hash && this.formGroupOrder.value.employees_hash.length > 0) {
      let error: number = 0;
      this.formGroupOrder.value.employees_hash.map(async (empHash) => {
        const employee = this.employeesList.find((emp) => emp.hash === empHash);
        if (!!employee.contract_start_date && !!employee.role && employee.role.toLowerCase() === "candidato") {
          if (moment(this.formGroupOrder.value.from) < moment(employee.contract_start_date.split("T")[0])) {
            error += 1;
            let textError = italian.data.ALERT.FUTURE_EMPLOYEE_ERROR_START_MESSAGE_ONE;
            textError += employee.complete_name;
            textError += italian.data.ALERT.FUTURE_EMPLOYEE_ERROR_START_MESSAGE_TWO;
            textError += moment(employee.contract_start_date.split("T")[0]).format("DD/MM//YYYY");
            await this._utilService.showSWALDeleteConfirmation({
              text: textError,
              title: "ALERT_TITLE",
              showCancelButton: false,
              confirmButtonText: "BTN_CLOSE",
              customClass: { confirmButton: "btn btn-warning" },
            });
            return false;
          }
        }
      });
      if (error > 0) return false;
    }

    //Check if they are trying to insert an order older than the current orders
    if (this.orderList && this.orderList.length > 0) {
      let errorsNum: number = 0;
      let originalEndDate: string = null;
      let roundBeforeId: string = null;
      let conflictRound: Object = null;
      let roundIsBiggerThanFromBefore: boolean = false;

      this.orderList.map((el: any) => {
        if (moment(this.formGroupOrder.value.from) > moment(el.from) && moment(this.formGroupOrder.value.from) <= moment(el.to)) {
          roundBeforeId = el.order_id;
          originalEndDate = el.to;
          errorsNum += 1;
          conflictRound = el;
        }
        if (moment(this.formGroupOrder.value.from) <= moment(el.from) && moment(this.formGroupOrder.value.from) <= moment(el.to)) {
          roundIsBiggerThanFromBefore = true;
        }
      });
      if (roundIsBiggerThanFromBefore) {
        await this._utilService.showSWALError({ text: "ERROR_DATE_ROUND_CONFLICT" });
        return false;
      }
      if (errorsNum > 0) {
        //Faccio decidere all'utente se vuole impostare il round in conflitto come data di scadenza il giorno prima alla data di partenza del nuovo round
        await this.modalOpen(this.roundConflictDecision, null);
        this.conflictRoundDetail = {
          originalEndDate: originalEndDate,
          newEndDate: moment(this.formGroupOrder.value.from).subtract(1, "days").format("YYYY-MM-DD"),
          roundBeforeId: roundBeforeId,
          conflictRound: conflictRound,
        };
        return false;
      }
    }
    //Check in case task tranche_number and tranche_import
    if (this.typeDeal === "Task") {
      if (!this.formGroupOrder.value.tranche_import || this.formGroupOrder.value.tranche_import == "0" || !this.formGroupOrder.value.tranche_number) {
        await this._utilService.showSWALError({ text: "ERROR_TRANCHE_TASK" });
        return false;
      }
      if (this.taskEmployee && this.taskEmployee.length > 0) {
        this.taskEmployee.map((emp) => {
          if (!emp.tranche_single_import || emp.tranche_single_import == 0 || !emp.monthly_import || emp.monthly_import === 0) {
            taskUsersError = true;
          }
        });
      }
      //Check in case of Time Material for each employee if they have effort and daily_rate
    } else {
      if (this.timeMaterialEmployee && this.timeMaterialEmployee.length > 0) {
        this.timeMaterialEmployee.map((emp) => {
          if (!emp.effort || emp.effort == 0 || !emp.daily_rate) {
            timeMaterialUsersError = true;
          }
        });
      }
    }
    //If we have an error in the employee array we'll show an error message
    if (timeMaterialUsersError) {
      await this._utilService.showSWALError({ text: "ERROR_TIME_MATERIAL_EFFORT_OR_DAILY_RATE" });
      return false;
    }
    if (taskUsersError) {
      this._utilService.hideLoading();
      await this._utilService.showSWALError({ text: "ERROR_TASK_SINGLE_TRANCHE_IMPORT" });
      return false;
    }
    //Controllo se è stato caricato un file come ordine debbano essere riempiti i campi numero ordine e data ordine
    if ((this.files_list && this.files_list.length > 0) || this.isCopingPrevDocument) {
      if (!this.formGroupOrder.value.order_number || !this.formGroupOrder.value.order_date) {
        await this._utilService.showSWALError({ text: "ERROR_ORDER_DATE_NUMBER_REQUIRED" });
        return false;
      }
    }
    this._utilService.showLoading();
    let a: number[] = [0];
    if (this.formGroupDetail.value.detachment) {
      a.push(1);
    }
    await Promise.all(
      a.map(async (el: number) => {
        const data: IRound = {
          billing_frequency: this.formGroupOrder.value.billing_frequency,
          capacity: this.formGroupOrder.value.capacity,
          client_approval: this.formGroupOrder.value.client_approval,
          commission_id: this.currentCommission.id,
          deal_id: this.formGroupOrder.value.deal_id,
          description: this.formGroupOrder.value.description,
          detachment_type: a.length > 1 ? (el === 0 ? "distacco" : "delta") : null,
          detail_task: this.taskEmployee,
          detail_time_material: this.timeMaterialEmployee,
          employees_hash: this.formGroupOrder.value.employees_hash,
          file_url: this.isCopingPrevDocument ? this.orderList[this.orderList.length - 1].file_url : null,
          from: this.formGroupOrder.value.from,
          invoice_type: this.formGroupOrder.value.invoice_type,
          order_cig: this.formGroupOrder.value.order_cig || null,
          order_cup: this.formGroupOrder.value.order_cup,
          order_date: !!this.formGroupOrder.value.order_date ? this.formGroupOrder.value.order_date : null,
          order_description: this.formGroupOrder.value.order_description,
          order_number: this.formGroupOrder.value.order_number,
          payment_measure_unit: this.formGroupOrder.value.payment_measure_unit,
          payment_terms: this.formGroupOrder.value.payment_terms,
          product_commission_id: this.formGroupOrder.value.product_commission_id,
          residue: this.formGroupOrder.value.residue,
          to: moment(this.formGroupOrder.value.to).add(23, "hours").add(59, "minutes").add(59, "seconds").format("YYYY-MM-DD HH:mm:ss"),
          tranche_import: this.formGroupOrder.value.tranche_import,
          tranche_number: this.formGroupOrder.value.tranche_number,
        };
        await this._orderService
          .addOrder(data)
          .then(async (res: any) => {
            if (el === 0) {
              //If there are files or attachments we're gonna the upload with the order_id
              if (res && res.order_id) {
                if (this.files_list && this.files_list.length > 0) {
                  this._utilService.hideLoading();
                  await this.uploadFiles(res.order_id);
                }
                if (this.attachments_list && this.attachments_list.length > 0) {
                  this._utilService.hideLoading();
                  await this.uploadAttachments(res.order_id);
                }
              }
            }
            if (a.length > 1 && el === 1) {
              //Se ci sono due chiamate chiamiamo al momento del delta una sola volta il refresh delle list ecc.
              this._utilService.hideLoading();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_CREATE_ROUND" });
              this.modalClose();
              await this.loadCommission();
            }
            if (a.length === 1 && el === 0) {
              //Se ce una chiamata effettuiamo il refreshing delle liste nel primo elemento del map
              this._utilService.hideLoading();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_CREATE_ROUND" });
              this.modalClose();
              await this.loadCommission();
            }
            this.isCopingPrevDocument = false;
          })
          .catch(async () => {
            this._utilService.hideLoading();
            await this._utilService.showSWALError({ text: "ERROR_CREATE_ROUND" });
          });
      }),
    );
  }

  async editOrder() {
    if (!this._authService.hasCapability("edit_order")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    this.showErrors = false;
    let timeMaterialUsersError: boolean = false;
    let taskUsersError: boolean = false;

    if (this.formGroupOrder.invalid) {
      await this._utilService.showSWALError({ text: "ERROR_EMPTY_FIELDS" });
      this.showErrors = true;
      return false;
    }
    //Check date
    if (moment(this.formGroupOrder.value.from) > moment(this.formGroupOrder.value.to)) {
      this.showErrors = true;
      await this._utilService.showSWALError({ text: "ERROR_DATE" });
      return false;
    }
    //Check Candidate Start Contract
    if (this.formGroupOrder.value.employees_hash && this.formGroupOrder.value.employees_hash.length > 0) {
      let error: number = 0;
      this.formGroupOrder.value.employees_hash.map(async (empHash: any) => {
        const employee = this.employeesList.find((emp: any) => emp.hash === empHash);
        if (!!employee.contract_start_date && employee.role && employee.role.toLowerCase() === "candidato") {
          if (moment(this.formGroupOrder.value.from) < moment(employee.contract_start_date.split("T")[0])) {
            error += 1;
            let textError = italian.data.ALERT.FUTURE_EMPLOYEE_ERROR_START_MESSAGE_ONE;
            textError += employee.complete_name;
            textError += italian.data.ALERT.FUTURE_EMPLOYEE_ERROR_START_MESSAGE_TWO;
            textError += moment(employee.contract_start_date.split("T")[0]).format("DD/MM//YYYY");
            await this._utilService.showSWALDeleteConfirmation({
              text: textError,
              title: "ALERT_TITLE",
              showCancelButton: false,
              confirmButtonText: "BTN_CLOSE",
              customClass: { confirmButton: "btn btn-warning" },
            });
            return false;
          }
        }
      });
      if (error > 0) return false;
    }

    if (!this.formGroupDetail.value.detachment) {
      //Check if they are trying to insert an order older than the current orders, for the edit function we sort the orders and take the last one
      let orders = this.orderList.sort((a, b) => (moment(b.to) > moment(a.to) ? 1 : -1));
      if (orders && orders.length > 0) {
        let errorsNum: number = 0;
        let originalEndDate: string = null;
        let roundBeforeId: string = null;
        let conflictRound: Object = null;
        this.orderList.map((el: any) => {
          if (moment(this.formGroupOrder.value.from) > moment(el.from) && moment(this.formGroupOrder.value.from) <= moment(el.to) && el.order_id !== this.selectedOrder.order_id) {
            roundBeforeId = el.order_id;
            originalEndDate = el.to;
            errorsNum += 1;
            conflictRound = el;
          }
        });

        if (errorsNum > 0) {
          //Faccio decidere all'utente se vuole impostare il round in conflitto come data di scadenza il giorno prima alla data di partenza del nuovo round
          await this.modalOpen(this.roundConflictDecision, false);
          this.conflictRoundDetail = {
            originalEndDate: originalEndDate,
            newEndDate: moment(this.formGroupOrder.value.from).subtract(1, "days").format("YYYY-MM-DD"),
            roundBeforeId: roundBeforeId,
            conflictRound: conflictRound,
          };
          return false;
        }
      }
    }
    //Check in case task tranche_number and tranche_import
    if (this.typeDeal === "Task") {
      if (!this.formGroupOrder.value.tranche_import || !this.formGroupOrder.value.tranche_number) {
        await this._utilService.showSWALError({ text: "ERROR_TRANCHE_TASK" });
        return false;
      }
      if (this.taskEmployee && this.taskEmployee.length > 0) {
        this.taskEmployee.map((emp) => {
          if (!emp.tranche_single_import || emp.tranche_single_import == 0) {
            taskUsersError = true;
          }
        });
      }
      //Check in case of Time Material for each employee if they have effort and daily_rate
    } else {
      if (this.timeMaterialEmployee && this.timeMaterialEmployee.length > 0) {
        this.timeMaterialEmployee.map((emp) => {
          if (!emp.effort || emp.effort == 0 || !emp.daily_rate) {
            timeMaterialUsersError = true;
          }
        });
      }
    }
    //If we have an error in the employee array we'll show an error message
    if (timeMaterialUsersError) {
      await this._utilService.showSWALError({ text: "ERROR_TIME_MATERIAL_EFFORT_OR_DAILY_RATE" });
      return false;
    }
    if (taskUsersError) {
      this._utilService.hideLoading();
      await this._utilService.showSWALError({ text: "ERROR_TASK_SINGLE_TRANCHE_IMPORT" });
      return false;
    }
    //Controllo se è stato caricato un file come ordine debbano essere riempiti i campi numero ordine e data ordine
    if ((this.files_list && this.files_list.length > 0) || !!this.order_document) {
      if (!this.formGroupOrder.value.order_number || !this.formGroupOrder.value.order_date) {
        await this._utilService.showSWALError({ text: "ERROR_ORDER_DATE_NUMBER_REQUIRED" });
        return false;
      }
    }

    let a: number[] = [0];
    if (this.formGroupDetail.value.detachment) {
      a.push(1);
    }
    //Controllo se la capienza è stata cambiata aggiorniamo il residuo
    let updatedResidueAmount = null;
    let isAnIncrement: boolean = false;
    //Controllo che la capacità sia stata aggiornata e che il residuo sia diverso da capacità, nel caso siano uguali significa che non è stata fatta alcuna operazione quindi il residuo rimane uguale alla capacità
    if (this.formGroupOrder.value.capacity !== this.selectedOrder.capacity && this.selectedOrder.residue !== this.selectedOrder.capacity) {
      //Se la capienza nuova è maggiore della capienza salvata a db è un incremento e aggiungiamo la differenza tra le due al residuo cosi da poterlo aggiornare
      if (this._utilService.removeDotsFromNumber(this.formGroupOrder.value.capacity) > this._utilService.removeDotsFromNumber(this.selectedOrder.capacity)) {
        isAnIncrement = true;
        updatedResidueAmount = this._utilService.removeDotsFromNumber(this.formGroupOrder.value.capacity) - this._utilService.removeDotsFromNumber(this.selectedOrder.capacity);
      } else {
        //sottraiamo la differenza tra le due al residuo cosi da poterlo aggiornare
        updatedResidueAmount = this._utilService.removeDotsFromNumber(this.selectedOrder.capacity) - this._utilService.removeDotsFromNumber(this.formGroupOrder.value.capacity);
      }
    }
    this._utilService.showLoading();
    const findDelta = this.orderList.find((el) => el.detachment_type === "delta" && el.deal_id === this.formGroupOrder.value.deal_id);
    await Promise.all(
      a.map(async (el: number) => {
        let data: IRound = {
          deal_id: this.formGroupOrder.value.deal_id,
          employees_hash: this.formGroupOrder.value.employees_hash,
          from: this.formGroupOrder.value.from,
          detachment_type: a.length > 1 ? (el === 0 ? "distacco" : "delta") : null,
          to: moment(this.formGroupOrder.value.to).format("YYYY-MM-DD[ 23:59:59]"),
          capacity: this.formGroupOrder.value.capacity,
          residue: !!updatedResidueAmount
            ? isAnIncrement
              ? this._utilService.addDotsToNumber(this._utilService.removeDotsFromNumber(this.selectedOrder.residue) + updatedResidueAmount)
              : this._utilService.addDotsToNumber(this._utilService.removeDotsFromNumber(this.selectedOrder.residue) - updatedResidueAmount)
            : this.formGroupOrder.value.residue,
          invoice_type: this.formGroupOrder.value.invoice_type,
          payment_measure_unit: this.formGroupOrder.value.payment_measure_unit,
          order_number: this.formGroupOrder.value.order_number,
          order_date: !!this.formGroupOrder.value.order_date ? this.formGroupOrder.value.order_date : null,
          description: this.formGroupOrder.value.description,
          order_description: this.formGroupOrder.value.order_description,
          payment_terms: this.formGroupOrder.value.payment_terms,
          billing_frequency: this.formGroupOrder.value.billing_frequency,
          detail_task: this.taskEmployee,
          detail_time_material: this.timeMaterialEmployee,
          tranche_import: this.formGroupOrder.value.tranche_import,
          tranche_number: this.formGroupOrder.value.tranche_number,
          client_approval: this.formGroupOrder.value.client_approval,
          commission_id: this.currentCommission.id,
          product_commission_id: this.formGroupOrder.value.product_commission_id,
          order_cig: this.formGroupOrder.value.order_cig || null,
          order_cup: this.formGroupOrder.value.order_cup,
        };
        if (el === 0) {
          //If there are files or attachments we're gonna the upload with the order_id
          if (this.selectedOrder.order_id) {
            if (this.files_list && this.files_list.length > 0) {
              this._utilService.hideLoading();
              await this.uploadFiles(this.selectedOrder.order_id);
            }
            if (this.attachments_list && this.attachments_list.length > 0) {
              this._utilService.hideLoading();
              await this.uploadAttachments(this.selectedOrder.order_id);
            }
          }
        }
        await this._orderService
          .editOrder(el === 0 ? this.selectedOrder.order_id : findDelta.order_id, data)
          .then(async () => {
            if (a.length > 1 && el === 1) {
              //Se ci sono due chiamate chiamiamo al momento del delta una sola volta il refresh delle list ecc.
              this.modalClose();
              await this.loadCommission();
              this._utilService.hideLoading();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_ROUND" });
            }
            if (a.length === 1 && el === 0) {
              //Se ce una chiamata effettuiamo il refreshing delle liste nel primo elemento del map
              this.modalClose();
              await this.loadCommission();
              this._utilService.hideLoading();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_ROUND" });
            }
          })
          .catch(async (err: any) => {
            console.error(err);
            this._utilService.hideLoading();
            await this._utilService.showSWALError({ text: "ERROR_EDIT_ROUND" });
          });
      }),
    );
  }

  async deleteOrder(order_id: number) {
    if (!this._authService.hasCapability("delete_order")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    await this._utilService
      .showSWALDeleteConfirmation({ text: "ALERT.CONFIRM_DELETE_TEXT" })
      .then(async (result) => {
        if (result.value) {
          this._utilService.showLoading();
          await this._orderService
            .deleteOrder(order_id)
            .then(async () => {
              this.orderList = this.orderList.filter((item) => item.order_id != order_id);
              await this.loadCommission();
              //If there are no order we open automatically the modal for insert another order
              if (!this.orderList || this.orderList.length < 1) {
                await this.modalOpen(this.detailOrder, null);
              }
              this._utilService.hideLoading();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_DELETE_ROUND" });
            })
            .catch(async (err: any) => {
              this._utilService.hideLoading();
              if (err == "This order has one or more reports.") {
                await this._utilService.showSWALError({ text: "ERROR_DELETE_ROUND_TO_MANY_REPORTS" });
              } else {
                await this._utilService.showSWALError({ text: "ERROR_DELETE_ROUND" });
              }
            });
        } else if (result.isDismissed) {
          this._utilService.hideLoading();
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_DELETE_ROUND" });
      });
  }

  async editCommission() {
    if (!this._authService.hasCapability("edit_commission")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this._utilService.showLoading();
    let data: any = {
      client_id: this.formGroupDetail.value.customer,
      name: this.formGroupDetail.value.name,
    };
    if (!!data.name) {
      data.name = data.name.trim();
    }
    if (!data.name || data.name.length < 1) {
      this._utilService.hideLoading();
      await this._utilService.showSWALError({ text: "ERROR_NAME_REQUIRED" });
      return false;
    }
    await this._commissionService
      .editCommission(this.commissionID, data)
      .then(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_COMMISSION" });
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_EDIT_COMMISSION" });
      });
  }

  async addNewChildOrder() {
    if (!this._authService.hasCapability("edit_order")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this._utilService.showLoading();
    if (this.formNewOrder.invalid) {
      await this._utilService.showSWALError({ text: "ERROR_EMPTY_FIELDS" });
      this.showErrors = true;
      return false;
    }
    let data = this.formNewOrder.value;
    data.order_id = this.selectedOrder.id;
    await this._commissionService
      .addNewOrder(data)
      .then(async (result: { message: string; order_id: number }) => {
        if (this.childOrderFile && typeof this.childOrderFile !== "string") {
          await this._orderService.uploadOrderChildAttachment(this.childOrderFile, Number(result.order_id));
        }
        this.modalCloseNewOrder();
        this.modalClose();
        await this.loadCommission();
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_CREATE_ORDER" });
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_CREATE_ORDER" });
      });
  }

  async editChildOrder() {
    if (!this._authService.hasCapability("edit_order")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this._utilService.showLoading();
    if (this.formNewOrder.invalid) {
      await this._utilService.showSWALError({ text: "ERROR_EMPTY_FIELDS" });
      this.showErrors = true;
      return false;
    }
    let data = this.formNewOrder.value;
    await this._commissionService
      .editNewOrder(this.selectedOrderChild.id, data)
      .then(async () => {
        if (this.childOrderFile && typeof this.childOrderFile !== "string") {
          await this._orderService.uploadOrderChildAttachment(this.childOrderFile, Number(this.selectedOrderChild.id));
        }
        this.modalCloseNewOrder();
        this.modalClose();
        await this.loadCommission();
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_ORDER" });
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_EDIT_ORDER" });
      });
  }

  async deleteChildOrder(order_id: number) {
    if (!this._authService.hasCapability("delete_order")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    await this._utilService
      .showSWALDeleteConfirmation({ text: "ALERT.CONFIRM_DELETE_TEXT" })
      .then(async (result) => {
        if (result.value) {
          this._utilService.showLoading();
          await this._commissionService
            .deleteNewOrder(order_id)
            .then(async () => {
              this.modalCloseNewOrder();
              this.modalClose();
              await this.loadCommission();
              this._utilService.hideLoading();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_DELETE_ORDER" });
            })
            .catch(async () => {
              this._utilService.hideLoading();
              await this._utilService.showSWALError({ text: "ERROR_DELETE_ORDER" });
            });
        } else if (result.isDismissed) {
          this._utilService.hideLoading();
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_DELETE_ORDER" });
      });
  }

  async closeCommission() {
    if (!this._authService.hasCapability("edit_commission")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    if (!this.closeDate) {
      await this._utilService.showSWALError({ text: "INSERT_DATE" });
      return false;
    }
    this._utilService.showLoading();
    const data: any = {
      status: 1,
      status_note: this.closeMotivation,
      closed_date: this.closeDate,
    };
    this._commissionService
      .editStatusCommission(this.commissionID, data)
      .then(async () => {
        this.modalClose();
        await this.loadCommission();
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_CLOSE_COMMISSION" });
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_CLOSE_COMMISSION" });
      });
  }

  async reOpenCommission() {
    if (!this._authService.hasCapability("edit_commission")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this._utilService.showLoading();
    this._commissionService
      .editStatusCommission(this.commissionID, {
        status: 0,
        status_note: "",
        closed_date: null,
      })
      .then(async () => {
        await this.loadCommission();
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_REOPEN_COMMISSION" });
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_REOPEN_COMMISSION" });
      });
  }

  async reloadCommissionEconomic(order_id: number, month: number, year: number, employees: object[]) {
    if (order_id && month && year && employees && employees.length > 0) {
      const employeesNumber: number = employees.length;
      let confirmationText: string = `${await this._utilService.translate("ALERT.CONFIRM_REGENERATE_TEXT_MODAL")} ${employeesNumber} ${employees.length === 1 ? await this._utilService.translate("ALERT.CONFIRM_REGENERATE_TEXT_MODAL_SECOND_SINGULAR") : await this._utilService.translate("ALERT.CONFIRM_REGENERATE_TEXT_MODAL_SECOND")
        }`;
      await this._utilService.showSWALDecision({ text: confirmationText, confirmButtonText: "CONFIRM_REGENERATE_BTN" }).then(async (result) => {
        if (result.value) {
          this._utilService.showLoading();
          await this._commissionService
            .reloadCommissionAnalytics(order_id, month, year)
            .then(async () => {
              await this.loadCommission();
              this._utilService.hideLoading();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_RELOAD_ECONOMIC" });
            })
            .catch(async (error) => {
              if (error === "Commission analytics deleted because it should not exists") {
                await this.loadCommission().then(() => this._utilService.hideLoading());
              } else {
                this._utilService.hideLoading();
                await this._utilService.showSWALError({ text: "ERROR_RELOAD_ECONOMIC" });
              }
            });
        } else if (result.isDismissed) {
          await this._utilService.showSWALInfo({
            text: "CANECEL_TEXT",
          });
        }
      });
    } else {
      await this._utilService.showSWALError({ text: "ERROR_RELOAD_MISS_FILED" });
    }
  }

  //Funzione per copiare i dati dall'ordine precedente quando si sta aggiungendo un round
  async copyPrevOrderDetails(showError: boolean = true) {
    const prevOrder = this.orderList[this.orderList.length - 1];
    if (showError && !prevOrder.order_description && !prevOrder.order_number && !prevOrder.order_date) {
      await this._utilService.showSWALError({ text: "ERROR_NO_ORDER_FROM_PREV_ORDER" });
      return false;
    }
    this.formGroupOrder.patchValue({
      order_description: prevOrder.order_description,
      order_number: prevOrder.order_number,
      order_cig: prevOrder.order_cig,
      order_cup: prevOrder.order_cup,
      order_date: prevOrder?.order_date ? this._utilService.formatDate(prevOrder.order_date, "YYYY-MM-DD") : null,
      capacity: this._utilService.addDotsToNumber(this._utilService.removeDotsFromNumber(prevOrder.capacity)),
      residue: this._utilService.addDotsToNumber(this._utilService.removeDotsFromNumber(prevOrder.residue)),
    });
    this.isCopingPrevOrderDetail = true;
    const inputOrderDate: any = document.querySelector("#order_date input");
    inputOrderDate.value = prevOrder?.order_date ? this._utilService.formatDate(prevOrder.order_date, "DD-MM-YYYY") : "";
  }

  costTooltip(type: "task" | "time-material", column: "estimated_cost" | "estimated_revenue" | "real_profit" | "real_cost", emp: any, row: any = null) {
    if (emp.type_code == "product" || (type === "task" && column !== "estimated_cost" && column !== "estimated_revenue")) {
      return null;
    }

    if (row) {
      if (this.currentCommission.detachment && row.detachment_type == "distacco") {
        const delta = this.currentCommission.commission_analytics.find((anal) => anal.detachment_type === "delta" && anal.order_id == row.order_number && anal.month == row.month_value && anal.year == row.year_value);
        if (delta) {
          const findEmp = delta.employees_analytics.find((anal) => anal.hash === emp.employee_hash);
          return findEmp.cost_total_daily + " x " + delta.working_days + (emp.commissions_number > 1 ? ` / ${emp.commissions_number}` : "");
        }
      }
    }

    if (type === "task" && column === "estimated_revenue") {
      const multiplier = this._utilService.removeDotsFromNumber(emp.estimated_revenue) / emp.working_days;
      return `${this._utilService.addDotsToNumber(multiplier)} x ${emp.working_days}`;
    }

    if (column == "estimated_revenue") {
      return emp.daily_rate + " x " + (emp.invoiced_days || emp.working_days);
    } else if (column == "real_profit") {
      return emp.daily_rate + " x " + emp.invoiced_days;
    } else {
      let text: string = emp.daily_cost + " x " + emp.working_days;
      text += emp.commissions_number > 1 ? ` / ${emp.commissions_number}` : "";
      return text;
    }
  }

  duplicateOrder(deal_id: number) {
    this._utilService.showLoading();
    this._dealService
      .duplicate(deal_id, this.orderList.length + 1)
      .then(async (result: any) => {
        this.dealsList = await this._dealService.getDeals();
        this.dealsFilteredList = this.dealsList.map((i) => i);
        await this.modalOpen(this.detailOrder, null).then(() => {
          const prevOrder = this.orderList[this.orderList.length - 1];
          this.selectedDeal = this.dealsList.find((deal) => deal.id === result.id);

          this.formGroupOrder.patchValue({
            ...prevOrder,
            ...prevOrder,
            deal_id: result.id,
            order_date: null,
            order_number: null,
            order_description: null,
            from: null,
            to: null,
            employees_hash: prevOrder.employees_hash.filter((hash: string) => !!this.employeesList.find((u) => u.hash === hash)),
            employees_names: prevOrder.employees_names.filter((name: string) => !!this.employeesList.find((u) => u.complete_name === name)),
          });

          this.typeDeal = prevOrder.detail_task && Object.keys(prevOrder.detail_task).length > 0 ? "Task" : "Time Material";
          this.timeMaterialEmployee = prevOrder.detail_time_material;
          this.taskEmployee = prevOrder.detail_task.filter((emp) => !!this.employeesList.find((u) => u.hash === emp.employee_hash));
          this.isCopingPrevDocument = false;

          this.takeDate(null, "from");
          this.takeDate(null, "to");
          this.formGroupOrder.patchValue({
            capacity: null,
            residue: null,
          });
          this._utilService.hideLoading();
        });
      })
      .catch((err: any) => {
        console.error(err);
        this._utilService.hideLoading();
        this._utilService.showToastrError("ERROR_DUPLICATE_DEAL");
      });
  }

  toggleCheckCopyDocument() {
    const input: any = document.querySelector("#copyDocumentOrder");
    const checked = !this.isCopingPrevDocument;
    input.checked = checked;
    this.isCopingPrevDocument = checked;
  }

  async regenerateAnalytics() {
    const month = Number(this.regenerateMonth);
    const year = Number(this.regenerateYear);

    if (month < 1) return false;

    const orders: number[] = this.orderList
      .filter((order: any) => {
        const startMonth = moment(order.from).month() + 1;
        const startYear = moment(order.from).year();

        const endMonth = moment(order.to).month() + 1;
        const endYear = moment(order.to).year();

        return (startMonth <= month && year === startYear) || (month <= endMonth && year === endYear);
      })
      .map((order: any) => Number(order.id));

    if (orders.length < 1) {
      return this._utilService.showToastrError("NO_ORDERS_FOR_THIS_MONTH");
    }

    this._utilService.showLoading();
    await Promise.all(orders.map((order_id: number) => this._commissionService.reloadCommissionAnalytics(order_id, month, year)))
      .then(async () => {
        await this.loadCommission();
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_RELOAD_ECONOMIC" });
      })
      .catch(async (error) => {
        if (error === "Commission analytics deleted because it should not exists") {
          await this.loadCommission().then(() => this._utilService.hideLoading());
        } else {
          this._utilService.hideLoading();
          await this._utilService.showSWALError({ text: "ERROR_RELOAD_ECONOMIC" });
        }
      });
  }
}
